import { useNavigate } from "react-router-dom";

const WorkOrderLink: React.FC<{
  workOrderNumber: string;
  canNavigate: boolean;
}> = ({ workOrderNumber, canNavigate }) => {
  const navigate = useNavigate();

  const onLinkClick = () => {
    navigate(`/work/work-orders/${workOrderNumber}`);
  };

  return (
    <>
      {canNavigate && (
        <div
          className="navlink"
          style={{ display: "inline-block" }}
          onClick={() => onLinkClick()}
        >
          {workOrderNumber}
        </div>
      )}
      {!canNavigate && <span>{workOrderNumber}</span>}
    </>
  );
};

export default WorkOrderLink;
